import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ESignGuard, ROUTE } from '@bizflex/data-access';
import { CALLBACK_URL } from '@portal/signing/document-signing';

const routerConfig: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  initialNavigation: 'enabledBlocking',
};

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ROUTE.VERIFICATION.MAIN,
  },
  {
    path: ROUTE.VERIFICATION.MAIN,
    loadChildren: () => import('@bizflex/verification/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.APPLICATION.MAIN,
    loadChildren: () => import('@bizflex/application/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.LEAD.MAIN,
    loadChildren: () => import('@bizflex/lead/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.LETTER_OF_OFFER.MAIN,
    loadChildren: () => import('@bizflex/letter-of-offer/shell').then(m => m.ShellModule),
  },
  {
    path: ROUTE.ERROR.MAIN,
    loadChildren: () => import('@bizflex/error-page').then(m => m.ErrorPageModule),
  },
  {
    path: ROUTE.SUCCESS.MAIN,
    loadChildren: () => import('@bizflex/success-page').then(m => m.SuccessPageModule),
  },
  {
    path: ROUTE.E_SIGN.MAIN,
    canActivate: [ESignGuard],
    loadChildren: () => import('@portal/signing/document-signing').then(m => m.DocumentSigningModule),
    providers: [
      {
        provide: CALLBACK_URL,
        useValue: [ROUTE.LETTER_OF_OFFER.MAIN, ROUTE.LETTER_OF_OFFER.CALLBACK],
      },
    ],
  },
  { path: '**', redirectTo: [ROUTE.ERROR.MAIN, ROUTE.ERROR.NOT_FOUND].join('/') },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerConfig)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
